import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const LocationPinIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    height: size,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.875 28.3594C10.875 28.3594 21.375 18.4089 21.375 10.8594C21.375 8.0746 20.2688 5.40389 18.2996 3.43475C16.3305 1.46562 13.6598 0.359375 10.875 0.359375C8.09023 0.359375 5.41951 1.46562 3.45038 3.43475C1.48125 5.40389 0.375 8.0746 0.375 10.8594C0.375 18.4089 10.875 28.3594 10.875 28.3594ZM10.875 16.1094C12.2674 16.1094 13.6027 15.5563 14.5873 14.5717C15.5719 13.5871 16.125 12.2518 16.125 10.8594C16.125 9.46699 15.5719 8.13163 14.5873 7.14706C13.6027 6.1625 12.2674 5.60938 10.875 5.60938C9.48261 5.60938 8.14726 6.1625 7.16269 7.14706C6.17812 8.13163 5.625 9.46699 5.625 10.8594C5.625 12.2518 6.17812 13.5871 7.16269 14.5717C8.14726 15.5563 9.48261 16.1094 10.875 16.1094Z",
    fill: color
  }));
};
export default LocationPinIcon;